export const HEADER_RIGHT_BUTTON_CIRCLE_ICON_SIZE = "16";

export const TAG_LEVEL_BY_HEADER_SIZE_MAP = {
    "27": "h1",
    "21": "h2",
    "17": "h3",
} as const;

export const TITLE_MIXIN_BY_HEADER_SIZE_MAP = {
    "17": "title-m",
    "21": "title-l",
    "27": "title-xl",
} as const;

export const SUBTITLE_MIXIN_BY_HEADER_SIZE_MAP = {
    "17": "body-m",
    "21": "body-l",
    "27": "body-l",
} as const;
